import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  RrcEp9WasteProfileInspector,
  RrcEp9WasteProfilesPage,
} from '@ots-frontend/ots-ui-tw';
export const RrcEp9WasteProfileKeyProfilePageRoute = () => {
  const [params] = useSearchParams();
  return (
    <RrcEp9WasteProfileKeyProfilePage
      profileKey={params.get('key') ?? undefined}
      tenantCode={params.get('tenantCode') ?? undefined}
    />
  );
};
export const RrcEp9WasteProfileKeyProfilePage = ({
  profileKey,
  tenantCode,
}: {
  profileKey?: string;
  tenantCode?: string;
}) => {
  const navigate = useNavigate();
  return (
    <RrcEp9WasteProfileInspector
      profileKey={profileKey}
      tenantCode={tenantCode}
      presentation="embedded"
      onClose={() => navigate(-1)}
    />
  );
};
export const RrcEp9WasteProfilesPageRoute = () => {
  const [params] = useSearchParams();
  return (
    <RrcEp9WasteProfilesPage
      objectId={params.get('objectId') ?? undefined}
      objectType={params.get('objectType') ?? undefined}
    />
  );
};
